import { LayoutModule } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AuthModule } from '@app/shared/auth/auth.module';
import { MaterialModule } from '@core/material.module';
import { FuseScrollbarModule } from '@keeps-platform-frontend-workspace/layout';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TranslocoModule } from '@jsverse/transloco';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { JobManagementModule } from '../job-management/job-management.module';
import {
  WorkspaceCreateDialogComponent,
  WorkspaceDarkSwitchComponent,
  WorkspaceFormComponent,
  WorkspacePageWrapperComponent,
} from './components';
import {
  WorkspaceImageUploadComponent,
  WorkspaceInfoComponent,
  WorkspaceLayoutComponent,
  WorkspaceProfileComponent,
  WorkspaceSettingsComponent,
} from './containers';
import { WorkspaceEffects } from './store/workspace.effects';
import { reducer } from './store/workspace.reducer';
import { featureKey } from './store/workspace.selectors';

export const DEFAUTL_WORKSPACE_PLACEHOLDER = 'https://assets.keepsdev.com/images/placeholders/company-placeholder.png';

import { Router } from '@angular/router';
import { WorkspaceService as WorkspaceDataService } from '@app/shared/store/data-services';
import { CreateWorkspaceDto } from '@app/shared/store/entities';
import { WorkspaceService } from '@keeps-platform-frontend-workspace/kp-keeps';
import { filter, map, switchMap } from 'rxjs/operators';
import { ImageUploadV2Component } from '@keeps-platform-frontend-workspace/ui/kp-image-upload-v2';
import { KpColorPaletteComponent } from '@keeps-platform-frontend-workspace/ui/kp-color-palette';
import { ColorPickerComponent } from '@keeps-platform-frontend-workspace/ui/kp-color-picker';
import { KpLoadingShadeComponent } from '@keeps-platform-frontend-workspace/ui/kp-loading-shade';
import { KpAppServicesConfigComponent } from '@keeps-platform-frontend-workspace/ui/kp-app-services-config';
import { SMTPComponent } from './containers/smtp/smtp.component';

@NgModule({
  declarations: [
    WorkspaceCreateDialogComponent,
    WorkspacePageWrapperComponent,
    WorkspaceProfileComponent,
    WorkspaceFormComponent,
    WorkspaceImageUploadComponent,
    WorkspaceDarkSwitchComponent,
    WorkspaceInfoComponent,
    WorkspaceLayoutComponent,
    WorkspaceSettingsComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslocoModule,
    MaterialModule,
    MatButtonModule,
    MatDialogModule,
    MatInputModule,
    MatFormFieldModule,
    MatProgressSpinnerModule,
    InfiniteScrollDirective,
    LayoutModule,
    FuseScrollbarModule,
    TranslocoModule,
    StoreModule.forFeature(featureKey, reducer),
    EffectsModule.forFeature([WorkspaceEffects]),
    AuthModule,
    JobManagementModule,
    ImageUploadV2Component,
    KpColorPaletteComponent,
    ColorPickerComponent,
    KpLoadingShadeComponent,
    KpAppServicesConfigComponent,
    SMTPComponent,
  ],
})
export class WorkspaceModule {
  constructor(
    private _router: Router,
    private _dialog: MatDialog,
    private _workspaceService: WorkspaceService,
    private _workspaceDataService: WorkspaceDataService,
  ) {
    this._workspaceService.createWorkspace$.subscribe(() => this.createWorkspace());
  }

  private createWorkspace() {
    const dialogRef = this._dialog.open(WorkspaceCreateDialogComponent);
    dialogRef
      .afterClosed()
      .pipe(
        filter((name) => !!name),
        map((name) => ({ name }) as CreateWorkspaceDto),
        switchMap((workspace) => this._workspaceDataService.add(workspace)),
      )
      .subscribe((workspace) => {
        this._workspaceService.setCurrentWorkspace(workspace as any);
        this._router.navigate(['workspace', 'profile']);
      });
  }
}
